import React from 'react';
import './VTS.css';
import FMSimage from '../Assets/VTS.jpg'; // First image (full size)
import FMSimage2 from '../Assets/vts1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/vts2.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/vts3.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/vts5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">VEHICLE TRACKING SYSTEM</h1>
                    <p className="FMS-description">

                    Here's a similar description for the Vehicle Tracking System:

The Vehicle Tracking System (VTS) from Vajra IoT offers an advanced solution to monitor and track vehicles in real-time. This system enhances fleet management, ensures the safety and security of vehicles, provides actionable insights for route optimization, and helps in reducing operational costs. With features like real-time tracking, geofencing, and driver behavior analysis, our Vehicle Tracking System is a crucial tool for modern transportation and logistics management.</p>                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Fuel Monitoring" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Real-Time Vehicle Tracking:</strong> Track vehicles' locations in real time, providing up-to-the-minute updates on their movement.</li>
    <li><strong>Geofencing:</strong> Set virtual boundaries for vehicles, and receive alerts when a vehicle enters or exits these areas.</li>
    <li><strong>Driver Behavior Monitoring:</strong> Monitor driving patterns, including speed, harsh braking, and acceleration, to ensure safe and efficient driving.</li>
    <li><strong>Route Optimization:</strong> Optimize vehicle routes to save fuel, reduce travel time, and increase operational efficiency.</li>
    <li><strong>Fuel Monitoring:</strong> Track fuel consumption and provide insights to reduce wastage and improve fuel efficiency.</li>
    <li><strong>Historical Data Analytics:</strong> Access historical trip data for reporting, analysis, and continuous improvement.</li>
</ul>

                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Centralized Monitoring:</strong> A web-based control system manages all vehicles, providing real-time tracking and status updates across predefined regions.</li>
    <li><strong>Automated Tracking:</strong> Vehicles are automatically tracked through GPS, ensuring seamless monitoring without manual intervention.</li>
    <li><strong>Route and Behavior Analysis:</strong> The system logs data about routes taken, speed, driving patterns, and fuel usage, offering actionable insights for better fleet management.</li>
</ul>

                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Vehicle Tracking System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                    <ul>
    <li><strong>Improved Fleet Management:</strong> Real-time tracking ensures efficient route planning, timely deliveries, and optimized fleet operations.</li>
    <li><strong>Enhanced Security:</strong> The system provides real-time location data and alerts for theft, unauthorized movements, or emergencies, ensuring vehicle safety.</li>
    <li><strong>Cost Savings:</strong> By monitoring fuel consumption, maintenance schedules, and driver behavior, the system helps reduce operational costs and improve efficiency.</li>
    <li><strong>Ease of Use:</strong> The intuitive, web-based platform makes tracking, reporting, and fleet management simple and accessible from anywhere.</li>
</ul>

                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our FMS */}
            {/* New Section: Industries Using Our FMS */}
<div className="FMS-bottom-heading">
    <h2 className="FMS-bottom-text">Industries Using Our System</h2>
</div>

<div className="FMS-content-container reverse-order-last">
    {/* Left side: Image for Industries */}
    <div className="FMS-image-container">
        <img src={FMSimage5} alt="Industries Using FMS" className="FMS-image smaller-size" />
    </div>

    {/* Right side: Text Content */}
    <div className="FMS-text">
        <p className="FMS-description">
        Our Vehicle Tracking System is trusted by various sectors to optimize fleet management, enhance security, and improve operational efficiency. These industries rely on our solution for its precision, reliability, and cost-saving benefits:           
        <ul>
    <li>Logistics & Transportation</li>
    <li>Fleet Management</li>
    <li>Public Transportation</li>
    <li>Delivery Services</li>
    <li>Construction & Mining</li>
</ul>
        </p>
    </div>
</div>

        </div>
    );
};

export default FMS;
